import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { MySubscriptions } from './MySubscriptions';
import { ProfileForm } from './ProfileForm';
import { DisplaySettings } from './DisplaySettings';
import { BaseLayout } from '@/shared/components/layout';
import { VerticalTab } from '@/shared/ui/custom/VerticalTab';
import { NotificationsList } from '@/features/notifications';

const ACCOUNT_TABS = new Set(['profile', 'display', 'subscriptions', 'notifications']);

export const AccountSettings: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get('tab') ?? 'profile';
  const activeTab = ACCOUNT_TABS.has(tabParam) ? tabParam : 'profile';

  const handleTabChange = (value: string) => {
    const nextParams = new URLSearchParams(searchParams);
    if (value === 'profile') {
      nextParams.delete('tab');
    } else {
      nextParams.set('tab', value);
    }
    setSearchParams(nextParams, { replace: true });
  };

  return (
    <BaseLayout>
      <div className="min-h-screen bg-background pt-24 pb-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Page Header */}
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-foreground">My Account</h1>
            <p className="text-muted-foreground mt-2">
              Manage your profile, subscriptions, and notifications
            </p>
          </div>

          <VerticalTab
            value={activeTab}
            onValueChange={handleTabChange}
            items={[
              { value: 'profile', label: 'Profile', content: <ProfileForm /> },
              { value: 'display', label: 'Display', content: <DisplaySettings /> },
              {
                value: 'subscriptions',
                label: 'My Subscriptions',
                content: <MySubscriptions />,
              },
              {
                value: 'notifications',
                label: 'Notifications',
                content: <NotificationsList />,
              },
            ]}
          />
        </div>
      </div>
    </BaseLayout>
  );
};
